/**
 * @author Daniel Aguirre
 * @file index.js
 * @description Dashboard Detail Container
 */

// Dependencies
import React from 'react';
// import PropTypes from 'prop-types';

// Components
import AppRoutes from '@nephro/components/AppRoutes';
import AppCardLayout from '@nephro/components/AppCardLayout';

// Routes
import routes from './routes';

/**
 * DashboardDetail Container.
 * @return { Node } React Educational Material container.
 */
const DashboardDetailContainer = () => {
  return (
    <AppCardLayout>
      <AppRoutes routes={routes} />
    </AppCardLayout>
  );
};

/**
 * @name DashboardDetail.propTypes
 * @type { Object }
 */
DashboardDetailContainer.propTypes = {};

/**
 * Default props
 */
DashboardDetailContainer.defaultProps = {};

export default DashboardDetailContainer;
